import React, { PropTypes } from 'react';
import pick from 'lodash/pick';

class VotingBaseForm extends React.Component {
  static propTypes = {
    publish: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    announceResult: PropTypes.func.isRequired,
    canSave: PropTypes.bool.isRequired,
    canPublish: PropTypes.bool.isRequired,
    canAnnounce: PropTypes.bool.isRequired
  };

  async save() {
    let { handleSubmit, save, values } = this.props;
    return await handleSubmit((data) => save(data))(values);
  }

  async publish() {
    let { handleSubmit, publish, values } = this.props;
    return await handleSubmit((data) => publish(data))(values);
  }

  async announceResult(data) {
    let { handleSubmit, announceResult, values } = this.props;
    return await handleSubmit(() => announceResult(data))(values);
  }

  getToolbarOptions() {
    let { submiting } = this.props;

    let toolbarProps = pick(this.props, [
      'canSave',
      'canPublish',
      'isPublished',
      'canAnnounceResult',
      'error'
    ]);

    toolbarProps.save = this.save.bind(this);
    toolbarProps.publish = this.publish.bind(this);
    toolbarProps.announceResult = this.announceResult.bind(this);
    toolbarProps.disabled = submiting;

    return toolbarProps;
  }
}

export default VotingBaseForm;





// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/VotingBaseForm.js